import styled from 'styled-components';
import { colors } from 'styles/colors';
import { primaryScrollbar } from 'styles/scrollbar';

export const GraphContainer = styled.div`
  height: 260px;
  width: 100%;
  display: flex;
  align-items: start;
  justify-content: center;

  .tooltip .tooltiptext::after {
    content: " ";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: black transparent transparent transparent;
  }

  ${primaryScrollbar}

  @media (max-width: 1024px) {
    overflow-x: auto;
    #health-card {
      padding-bottom: 20px;
      }
    }
`;

export const LegendContainer = styled.div`
  display: grid;
  gap: 16px;
  align-items: start;
  justify-items: start;

  grid-template-columns: repeat(4, auto);

  @media (max-width: 768px) {
    grid-template-columns: repeat(3, auto);

    & > div:nth-child(4) {
      grid-column-start: 2;
    }
  }
`;

export const LegendContent = styled.div`
  display: flex;
  align-items: start;
  justify-content: center;
  gap: 4px;

  & > span {
    font-weight: 400;
    font-size: 12px;
    color: ${colors.text['main-900']};
    line-height: 150%;
  }
`;
